import type { AssetDefinition, Furniture, Room, Wall } from "./types";

export const METERS_TO_PX = 46;
export const PLAN_OFFSET = { x: 68, y: 54 };

export const initialWalls: Wall[] = [
  { id: "w1", x1: 0, y1: 0, x2: 14.4, y2: 0, height: 2.6, thickness: 0.18, label: "14.40" },
  { id: "w2", x1: 14.4, y1: 0, x2: 14.4, y2: 8.1, height: 2.6, thickness: 0.18, label: "8.10" },
  { id: "w3", x1: 14.4, y1: 8.1, x2: 10.8, y2: 8.1, height: 2.6, thickness: 0.18, label: "3.60" },
  { id: "w4", x1: 10.8, y1: 8.1, x2: 10.8, y2: 9.6, height: 2.6, thickness: 0.18, label: "1.50" },
  { id: "w5", x1: 10.8, y1: 9.6, x2: 0, y2: 9.6, height: 2.6, thickness: 0.18, label: "10.80" },
  { id: "w6", x1: 0, y1: 9.6, x2: 0, y2: 0, height: 2.6, thickness: 0.18, label: "9.60" },
  { id: "w7", x1: 0, y1: 4.0, x2: 8.0, y2: 4.0, height: 2.6, thickness: 0.14, label: "7.39" },
  { id: "w8", x1: 4.0, y1: 0, x2: 4.0, y2: 4.0, height: 2.6, thickness: 0.14, label: "4.00" },
  { id: "w9", x1: 6.8, y1: 0, x2: 6.8, y2: 4.0, height: 2.6, thickness: 0.14, label: "2.80" },
  { id: "w10", x1: 8.0, y1: 4.0, x2: 8.0, y2: 7.15, height: 2.6, thickness: 0.14, label: "2.49" },
  { id: "w11", x1: 8.0, y1: 4.0, x2: 11.0, y2: 4.0, height: 2.6, thickness: 0.14, label: "2.93" },
  { id: "w12", x1: 11.0, y1: 4.0, x2: 11.0, y2: 8.1, height: 2.6, thickness: 0.14, label: "4.20" },
  { id: "w13", x1: 0, y1: 6.55, x2: 4.55, y2: 6.55, height: 2.6, thickness: 0.14, label: "3.60" },
  { id: "w14", x1: 4.55, y1: 6.55, x2: 4.55, y2: 9.6, height: 2.6, thickness: 0.14, label: "2.60" },
  { id: "w15", x1: 6.5, y1: 6.55, x2: 6.5, y2: 9.6, height: 2.6, thickness: 0.14, label: "1.65" },
  { id: "w16", x1: 4.55, y1: 7.9, x2: 8.0, y2: 7.9, height: 2.6, thickness: 0.14, label: "1.50" },
];

export const initialRooms: Room[] = [
  { id: "r1", name: "Bedroom", x: 0.2, y: 0.2, width: 3.6, depth: 3.6, tone: "#E8E1D5" },
  { id: "r2", name: "Guest room", x: 4.2, y: 0.2, width: 2.4, depth: 3.6, tone: "#E3DED2" },
  { id: "r3", name: "Living room", x: 7.0, y: 0.2, width: 7.2, depth: 3.6, tone: "#DEDCCF" },
  { id: "r4", name: "Office", x: 0.2, y: 4.2, width: 4.1, depth: 2.1, tone: "#E6DED1" },
  { id: "r5", name: "Bath", x: 4.75, y: 6.75, width: 1.55, depth: 2.65, tone: "#D9E2DF" },
  { id: "r6", name: "Hall", x: 4.75, y: 4.2, width: 3.0, depth: 2.1, tone: "#E5E0D7" },
  { id: "r7", name: "Kitchen", x: 8.2, y: 4.2, width: 2.6, depth: 3.7, tone: "#E2DDD1" },
  { id: "r8", name: "Utility", x: 11.2, y: 4.2, width: 3.0, depth: 3.7, tone: "#DCE0D8" },
];

export const assetLibrary: AssetDefinition[] = [
  { kind: "sofa", name: "Sofa", width: 2.2, depth: 0.9, color: "#507A6A" },
  { kind: "chair", name: "Lounge chair", width: 0.85, depth: 0.85, color: "#C9784C" },
  { kind: "table", name: "Dining table", width: 1.8, depth: 0.95, color: "#BD885D" },
  { kind: "bed", name: "Double bed", width: 1.8, depth: 2.0, color: "#7E8FA3" },
  { kind: "plant", name: "Plant", width: 0.65, depth: 0.65, color: "#3F765B" },
  { kind: "cabinet", name: "Sideboard", width: 1.6, depth: 0.45, color: "#D5B77E" },
];

export const initialFurniture: Furniture[] = [
  { id: "f-sofa", kind: "sofa", name: "Sofa", x: 10.7, y: 1.5, rotation: 0, width: 2.2, depth: 0.9, color: "#507A6A" },
  { id: "f-table", kind: "table", name: "Dining table", x: 8.4, y: 2.2, rotation: 90, width: 1.8, depth: 0.95, color: "#BD885D" },
  { id: "f-bed", kind: "bed", name: "Double bed", x: 1.1, y: 1.0, rotation: 0, width: 1.8, depth: 2.0, color: "#7E8FA3" },
  { id: "f-plant", kind: "plant", name: "Plant", x: 13.2, y: 2.7, rotation: 0, width: 0.65, depth: 0.65, color: "#3F765B" },
];
